
import { Component, Vue, Prop } from 'vue-property-decorator';
import kebabCase from 'lodash/kebabCase';
import mapKeys from 'lodash/mapKeys';

@Component
export default class BoxGrid extends Vue {
  @Prop({ default: '' }) title!: string;

  get bRowAttrs() {
    return {
      'align-v': 'stretch',
      'align-h': 'center',
      'align-content': 'stretch',
      cols: 12,
      ...mapKeys(this.$attrs, (v, k) => kebabCase(k)),
    };
  }
}
